import enumeration from "./enumeration";

const GuestStatus = {
  CHECKED_IN: "CHECKED_IN",
  CHECKED_OUT: "CHECKED_OUT",
};

export default enumeration(GuestStatus);
